import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import prepareQuery from '../../helpers/prepareQuery';
import { RequestError } from '../../types';
import { Payload, RequestResponse } from './types';

let promise: any;

const handleAbortSignal = () => {
  if (promise) {
    promise.abort();
  }
};

export const passportRecognition = createAsyncThunk<
  RequestResponse,
  Payload,
  { rejectValue: RequestError }
>('virtualCard/passportRecognition/fetch', async ({ formData, signal }, { rejectWithValue }) => {
  try {
    const url = '/_virtual_cards/abb/recognize-identification-data';
    const params = prepareQuery();

    promise = superagent.post(url).query(params).send(formData);

    signal.addEventListener('abort', handleAbortSignal);

    const data = await promise;

    if (data.body.error) {
      throw data.body.error;
    }

    return data.body.result as RequestResponse;
  } catch (error: any) {
    return rejectWithValue(error.response.body as RequestError);
  } finally {
    signal.removeEventListener('abort', handleAbortSignal);
  }
});
